/**
 * Excel + ZIP import calls (specs/dataset-workspace.md, #796). Each matching call
 * returns the import's fresh view: matched, unmatchedRows, unmatchedPdfs.
 */
import API_ENDPOINTS from '../../../config/api';
import { uploadFilesToStorage } from '../../../utils/storageUpload';

async function request(url, options = {}) {
  const res = await fetch(url, { credentials: 'include', ...options });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || `HTTP ${res.status}`);
  return body;
}

const post = (url, payload) => request(url, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload || {}),
});

export const getCurrentImport = (id) => request(API_ENDPOINTS.ADMIN_DATASET_IMPORT_CURRENT(id)).then((b) => b.import);

export async function startImport(id, { sources, archive, files = [] }, { onProgress } = {}) {
  // The ZIP and loose PDFs go straight to object storage (#973); only the small
  // Excel still travels in the request body.
  const big = [...(archive ? [archive] : []), ...files];
  const uploaded = big.length
    ? await uploadFilesToStorage(API_ENDPOINTS.ADMIN_DATASET_UPLOAD_URLS(id), big, { onProgress })
    : [];
  const form = new FormData();
  form.append('sources', sources);
  if (archive) {
    form.append('archiveKey', uploaded[0].key);
    form.append('archiveName', archive.name);
  }
  const fileKeys = uploaded.slice(archive ? 1 : 0);
  if (fileKeys.length) form.append('fileKeys', JSON.stringify(fileKeys));
  return request(API_ENDPOINTS.ADMIN_DATASET_IMPORTS(id), { method: 'POST', body: form });
}

export const matchPdf = (id, iid, pdfId, rowId) => post(API_ENDPOINTS.ADMIN_DATASET_IMPORT_ACTION(id, iid, 'match'), { pdfId, rowId });
export const unmatchRow = (id, iid, rowId) => post(API_ENDPOINTS.ADMIN_DATASET_IMPORT_ACTION(id, iid, 'unmatch'), { rowId });
export const keepPdf = (id, iid, pdfId, payload) => post(`${API_ENDPOINTS.ADMIN_DATASET_IMPORT_FILE(id, iid, pdfId)}/keep`, payload);
export const discardPdf = (id, iid, pdfId) => request(API_ENDPOINTS.ADMIN_DATASET_IMPORT_FILE(id, iid, pdfId), { method: 'DELETE' });
export const confirmImport = (id, iid) => post(API_ENDPOINTS.ADMIN_DATASET_IMPORT_ACTION(id, iid, 'confirm'));
export const cancelImport = (id, iid) => request(API_ENDPOINTS.ADMIN_DATASET_IMPORT(id, iid), { method: 'DELETE' });

/** What the PDF says it is: AI reading first, then the first page's title, then metadata. */
export function pdfTitle(pdf) {
  return pdf?.ai?.title || pdf?.titleGuess || pdf?.metaTitle || null;
}
export function pdfPublisher(pdf) {
  return pdf?.ai?.publisher || pdf?.metaAuthor || null;
}
